import flipToggleMulti from "./flipToggleMulti";
import flipToggleSingle from "./flipToggleSingle";

const flipToggleInit = () => {
    flipToggleSingle();
    flipToggleMulti();
};

export default flipToggleInit;
